/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Train_TitleInputs */

const en_features_train_title = /** @type {(inputs: Features_Train_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan says how much. You just lift.`)
};

const pl_features_train_title = /** @type {(inputs: Features_Train_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan mówi, ile. Ty tylko podnosisz.`)
};

/**
* | output |
* | --- |
* | "The plan says how much. You just lift." |
*
* @param {Features_Train_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_train_title = /** @type {((inputs?: Features_Train_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Train_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_train_title(inputs)
	return en_features_train_title(inputs)
});